import { observable, action } from 'mobx';
import moment from "moment-timezone";
import Utils from '../common/Utils'; 

export default class FilterBarStore {
  @observable announcementFilter = {
    date: Utils.currentUTCDate(),
    isMatchAnn: false,
  }

  @observable dateFilter = Utils.currentUTCDate();
  @observable sportFilter = 29;

  @action updateAnnouncementFilter(key, value) {
    this.announcementFilter[key] = value;
  }
  
  @action updateDateFilter(newDate) {
    this.dateFilter = newDate;
  }
  
  @action updateSportFilter(sportId) {
    this.sportFilter = sportId;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/FilterBarStore.js